import React from "react";
import { NodeEdge } from "@hex-insights/app-modules";
import { addTimeToDate, getDateTimeRange, stringToLocalDate } from "@hex-insights/core";
import { EventCalendarItem } from "../../types";
import { rangeDatedItemsToDateMap } from "../../utils";
import { TimedView, TimedViewProps } from "../TimedView";

export type BusinessWeekViewProps = {
	value: Date;
	events?: EventCalendarItem[] | NodeEdge<EventCalendarItem>[];
} & Omit<TimedViewProps, "values" | "dateEventMap">;

export function BusinessWeekView({ value, events, ...props }: BusinessWeekViewProps) {
	const values = React.useMemo(
		() => getDateTimeRange(value, addTimeToDate(value, [5, "days"]), "day").map((e) => stringToLocalDate(e, "day")),
		[value],
	);

	const dateEventMap = React.useMemo<Record<string, EventCalendarItem[]>>(() => {
		if (!events) {
			return {};
		}
		return rangeDatedItemsToDateMap(
			events,
			(e) => (e.isAllDay ? "startDate" : "startTime"),
			(e) => (e.isAllDay ? "endDate" : "endTime"),
			(e) => e.isAllDay,
		);
	}, [events]);

	return <TimedView values={values} dateEventMap={dateEventMap} {...props} />;
}
